export const closeMobileMenu = (config) => ({
    type: "CLOSE_MOBILE_MENU",
});

export const openMobileMenu = (config) => ({
    type: "OPEN_MOBILE_MENU",
});
